//FLASH MESSAGES
export const DEFAULT_FLASH_TITLE = 'Something went wrong'
export const DEFAULT_FLASH_DESCRIPTION =
    'Try refreshing this page or contact us.'
export const DEFAULT_REFRESH_MSG =
    'Something went wrong. Try refreshing this page or contact us.'

//Quotes
export const UPDATED_QUOTE_SUCCESS = 'Quote updated'

// UNSUPPORTED_REASON
const DUE_TO_UNSUPPORTED = 'due to unsupported file type(s)'

// DOWNLOAD ATTACHMENT
export const DOWNLOAD_BLOCKED_ATTACHMENT_ERROR = `Download failed ${DUE_TO_UNSUPPORTED}`
// UPLOAD BLOCKED EXT ATTACHMENT
export const UPLOAD_BLOCKED_ATTACHMENT_ERROR = `Upload failed ${DUE_TO_UNSUPPORTED}`
export const UPLOAD_BLOCKED_SOME_ATTACHMENTS_ERROR = `Some of attachment(s) failed to upload ${DUE_TO_UNSUPPORTED}`

//Download Model
export const BLOCKED_POPUPS_DOWNLOAD =
    'We failed to open your download because you have popups blocked.'

//Threads
export const FAILED_RECORD_THREADS =
    'We failed to record your thread specification. Please try again.'

//Orders
export const PERMISSION_DENIED_TITLE =
    'You don’t have permission to view this order'
export const PERMISSION_DENIED_DETAIL =
    'If you believe this is a mistake, please contact our support team.'
